<template>
    <section style="height: 100%">
        <v-style> body > :first-child { height: 100%; } </v-style>
        <MenuLayer :items="itemsLayer" v-show="layersActive" :x="layerX" :y="layerY"></MenuLayer>
        <Spinner v-if="loader"></Spinner>
        <ExportPdf
            v-if="displayViewPdf"
            :modules="getEltModules"
            :accessories="accessories"
            :hideFrame="optionhideframe"
            :preview="previewPdf"
            :compression="compression"
        ></ExportPdf>
        <div v-if="showTool === true">
            <div id="menuView" class="flexContainer jc-c full">
                <ul class="views flexContainer listNone center">
                    <!-- <li class="titleView pointer ff-medium uppercase">{{ $t('planobuilder.view') }}</li> -->
                    <li
                        class="pointer"
                        v-for="tab in tabs"
                        @click="views(tab.id, $event);"
                        :key="tab.id"
                        :class="[{ active: activeTab(tab.id), mobileNot: tab.id === 'shades' || tab.id === 'blackwhite' || tab.id === 'hide' }]"
                    >
                        {{ $t(tab.text) }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="flexContainer fd-c content-plano-builder">
            <div id="planoContainer" class="rel flexContainer">
                <div id="toolBar" class="mobileNot" v-if="showTool">
                    <ul class="listNone listAction">
                        <li
                            class="pointer"
                            v-if="lock === false"
                            @click="selectionAction"
                            :title="$t('planobuilder.selection')"
                            :class="{ selection: modeSelection, selectionSvg: modeSelection === false }"
                        ></li>
                        <li
                            class="pointer"
                            @click="panAction"
                            :class="{ pan: modePan, panAction: modePan === false }"
                            :title="$t('planobuilder.pan')"
                        ></li>
                        <li class="pointer icon-ungroup-off" @mousedown="removeGroupAll" :title="$t('planobuilder.ungroupall')"></li>
                    </ul>
                    <ul class="listNone listZoom">
                        <li class="zoomIn" @click="zoomIn" :title="$t('planobuilder.zoomIn')"></li>
                        <li class="zoomOut" @click="zoomOut" :title="$t('planobuilder.zoomOut')"></li>
                        <li
                            class="pointer"
                            v-if="lock === false"
                            @click="zoomModuleAction"
                            :class="{ moduleZ: zoomModule, zoomModule: zoomModule === false }"
                            :title="$t('planobuilder.zoomModule')"
                        ></li>
                        <li
                            class="pointer"
                            @click="planoPosInit"
                            @mousedown="planoPosInitMousedown"
                            :class="{ pos: posInit, posInit: posInit === false }"
                            :title="$t('planobuilder.posInit')"
                        ></li>
                    </ul>
                    <ul class="listNone listLayers">
                        <li
                            class="icon-layers"
                            @click="activeLayers"
                            :class="{ 'layers-on': layersActive, 'layers-off': layersActive === false }"
                        ></li>
                    </ul>
                </div>
                <svg id="builder" class="svg-builder" ref="builder"></svg>
            </div>
            <transition name="fade">
                <div
                    v-if="showTool && lock === false && hasAccessUpdate('plano_builder') && getShowRestore === false"
                    id="menuSelection"
                    class="flexContainer mobileNot"
                    :class="{ visibility: modeSelection === false }"
                >
                    <ul class="flexContainer listNone">
                        <li id="content-count">
                            <img src="./../../../static/assets/checked.svg" width="16px" height="16px" /> &#160;&#160;{{
                                countSelectComponents
                            }}
                            selected elements
                        </li>
                        <li class="pointer" id="editModule" @click="editModule" :class="{ disabled: countSelectModules < 1 }">
                            {{ $t("planoSelect.edit") }}
                        </li>
                        <li class="pointer" @click="duplicate" :class="{ disabled: countSelectModules < 1 }">{{ $t("planoSelect.duplicate") }}</li>
                        <li class="pointer" id="bt-group-module" :class="{ disabled: countSelectModules <= 1 }" @click="addGroup">
                            {{ $t("planoSelect.group") }}
                        </li>
                        <li class="pointer" id="bt-degroup-module" :class="{ disabled: groupSelected === null }" @click="removeGroup">
                            {{ $t("planoSelect.ungroup") }}
                        </li>
                        <!-- <li class="pointer" id="bt-degroup-all-module" @click="removeGroupAll"> -->
                        <!-- {{ $t('planoSelect.ungroupall') }} -->
                        <!-- </li> -->
                        <li class="pointer" :class="{ disabled: countSelectModules < 1 }" @click="addFav">{{ $t("planoSelect.addToFavorite") }}</li>
                        <li class="pointer" :class="{ disabled: countSelectModules < 1 }" @click="addScratch">
                            {{ $t("planoSelect.addToScratchpad") }}
                        </li>
                        <li class="pointer" :class="{ disabled: countSelectComponents < 1 }" @click="deleteModuleAction">
                            {{ $t("planoSelect.deleteModule") }}
                        </li>
                        <li class="content-highlight pointer">
                            Hightlight:
                            <span
                                class="pointer bt-highlight"
                                :class="{ disabled: countSelectComponents < 1 }"
                                v-for="highlightMenu in highlightsMenu"
                                :key="highlightMenu.id"
                                @click="() => highlightMenu.action.apply(null, highlightMenu.args)"
                                :style="'background-color:' + highlightMenu.args[1]"
                            ></span>
                        </li>
                        <li class="pointer" :class="{ disabled: countSelectComponents < 1 }" @click="addCommentAction">
                            {{ $t("planoSelect.addComment") }}
                        </li>

                        <!-- <li class="pointer" @click="exportXls"> -->
                        <!-- export xls -->
                        <!-- </li> -->
                        <li class="pointer abs" id="test" @click="test"></li>
                    </ul>
                </div>
            </transition>
            <ModalComment v-show="showCommentModal" @closeCommentModalEvent="closeCommentModal($event);"></ModalComment>
        </div>
    </section>
</template>
<script>
const d3 = require("d3");
import { mapGetters, mapActions } from "vuex";
import Globals from "./../globals";
import { i18n, bus } from "../../main";
import { stateMixin } from "./mixins/state";
import httpService from "../service";
import { planoMixin } from "./mixins/plano";
import { loadModulesMixin } from "./mixins/loadmodules";
import { componentMixin } from "./mixins/component";
import ExportPdf from "./ExportPdf.vue";
import MenuLayer from "./MenuLayer.vue";
import Spinner from "../common/Spinner";
import ModalComment from "./menu/ModalComment";
import cacheService from "@/services/cache";
// import service from '../service'
import Vue from "vue";

export default {
    mixins: [stateMixin, planoMixin, componentMixin, loadModulesMixin],
    components: { ExportPdf, Spinner, MenuLayer, ModalComment },
    data() {
        return {
            highlightsMenu: [
                {
                    label: { fr: "Bleu", en: "Blue" },
                    //                        label: {fr: 'Nouvelle teinte', en: 'New shade'},
                    action: this.newVisualComponent,
                    args: ["blue", "#41B4E8"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Rouge", en: "Red" },
                    action: this.newVisualComponent,
                    args: ["red", "#FF0000"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Violet", en: "Purple" },
                    action: this.newVisualComponent,
                    args: ["purple", "#8A2BE2"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Jaune", en: "Yellow" },
                    action: this.newVisualComponent,
                    args: ["yellow", "#FFD700"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Vert", en: "Green" },
                    action: this.newVisualComponent,
                    args: ["green", "#008000"]
                },
                {
                    label: { fr: "Annuler", en: "Cancel" },
                    action: this.newVisualComponent,
                    args: ["cancel"]
                }
            ],
            svg: null,
            selectedCampaign: cacheService.getCurrentCampaignId(),
            load: false,
            previewPdf: true,
            tabs: [],
            showTool: true,
            locale: i18n.locale,
            modePan: false,
            modeSelection: true,
            posInit: false,
            zoomModule: false,
            lock: false,
            planoData: {},
            accessories: [],
            groups: [],
            accessoriesSelected: [],
            modulesSelected: [],
            groupSelected: null,
            tabId: "iconscolors",
            tabSelected: "iconscolors",
            realistic: false,
            viewComment: true,
            tabhide: false,
            kZoom: 1,
            gZoom: null,
            viewticketstrip: false,
            displayViewPdf: false,
            optionhideframe: false,
            singleSelection: true,
            loader: true,
            zoomEvent: null,
            layerX: "0px",
            layerY: "0px",
            messageError: "",
            hasError: false,
            countErrorModule: 0,
            itemsLayer: [
                {
                    id: "ticketstrip",
                    action: { func: this.viewTicketstrip },
                    label: "planobuilder.ticketStrip",
                    active: false
                },
                {
                    id: "realistic",
                    action: { func: this.viewRealistic },
                    label: "planobuilder.realistic",
                    active: false
                },
                {
                    id: "frameHide",
                    action: { func: this.frameHide },
                    label: "planobuilder.frameHide",
                    active: true
                },
                {
                    id: "highlights",
                    action: { func: this.highlight },
                    label: "planobuilder.highlights",
                    active: true
                },
                {
                    id: "iconscolors",
                    action: { func: this.viewsModule, args: ["iconscolors"] },
                    label: "planobuilder.iconscolors",
                    active: false
                },
                {
                    id: "reference",
                    action: { func: this.viewsModule, args: ["reference"] },
                    label: "planobuilder.reference",
                    active: true
                },
                {
                    id: "modules",
                    action: { func: this.viewsModule, args: ["modules"] },
                    label: "planobuilder.modules",
                    active: true
                }
            ],
            layersActive: false,
            ungroupAll: false,
            showCommentModal: false,
            showRestore: false,
            compression: 100
        };
    },
    watch: {
        getLocale(locale) {
            this.getModules().forEach(mod => {
                let elt = d3.select("#" + mod.UUID).node();
                // this.loadConfigModule(elt, mod)
                this.preloadTextsIfNotTickets(elt, mod);
                this.loadTicketStrips(elt, mod, false);
            });

            this.reloadAccessoriesSeg();
        }
    },
    computed: {
        countSelectModules() {
            return this.modulesSelected.length;
        },
        countSelectComponents() {
            return this.modulesSelected.length + this.accessoriesSelected.length;
        },
        getAccessories() {
            return this.accessories;
        },
        getAccessoriesSelected() {
            return this.accessoriesSelected;
        },
        getEltModules() {
            let modules = this.getModules();
            let elts = [];
            let elt;
            modules.forEach(mod => {
                elt = document.getElementById(mod.UUID);
                elts.push(elt);
            });
            return elts;
        },
        ...mapGetters({
            getRestorePlano: "plano/data/getRestorePlano",
            getShowRestore: "plano/data/getShowRestore"
        })
    },
    created() {},
    mounted() {
        this.changeId();
        console.time("plano");

        let eltIconLayers = document.querySelector("ul li.icon-layers");
        // let elt = event.target
        let bb = eltIconLayers.getBoundingClientRect();
        // console.log(bb)
        this.layerX = bb.x + bb.width + 1 + "px";
        this.layerY = bb.y - 120 + "px";

        if (this.load === false) {
            let data;
            if (this.getShowRestore === true && cacheService.get("showRestore") !== "false") {
                data = this.getRestorePlano;
            } else {
                data = this.getMeuble;
            }

            this.loadDataPlano(data);
            this.drawplano();
            this.loadListeners();
            this.loadModules();
            this.loadAccessories();
            this.load = true;
        }

        bus.$on("fav_copyFav", obj => {
            this.copyFav(obj.event, obj.fav, obj.svg);
        });

        bus.$on("library_copy", (event, item) => {
            this.copy(event, item);
        });

        bus.$on("plano_save", mode => {
            // console.log('on plano save')
            this.save(mode);
        });

        bus.$on("plano_exportPreviewPdf", compression => {
            this.previewPdf = true;
            this.exportPdf(compression);
        });

        bus.$on("plano_exportPdf", compression => {
            this.previewPdf = false;
            this.exportPdf(compression);
        });

        bus.$on("plano_exportXls", () => {
            this.exportXls();
        });

        // this.activeLayers()
    },
    beforeDestroy() {
        this.tabhide = false;
        this.zoomEvent = null;
        this.setUpdatePlano(false);
        this.setRestorePlano();
        bus.$off("plano_save");
        bus.$off("plano_exportPdf");
        bus.$off("plano_exportPreviewPdf");
        bus.$off("plano_exportXls");
        bus.$off("library_copy");
        bus.$off("fav_copyFav");
        this.destroyMenu();
        this.setShowRestore(false);
    },
    methods: {
        addCommentAction() {
            this.showCommentModal = true;
        },
        closeCommentModal() {
            this.showCommentModal = false;
        },
        ...mapActions({
            setRestorePlano: "plano/data/setRestorePlano",
            setShowRestore: "plano/data/setShowRestore"
        }),
        changeId() {
            if (this.$route.params.id && sessionStorage.getItem("oldID") !== null) {
                if (sessionStorage.getItem("oldID") !== this.$route.params.id) {
                    this.updateLock(sessionStorage.getItem("oldID"), false);
                    sessionStorage.setItem("oldID", this.$route.params.id);
                }
            } else {
                sessionStorage.setItem("oldID", this.$route.params.id);
            }
        },
        updateLock(id, active) {
            httpService.post("/plano/" + id + "/back", JSON.stringify({ locked: active })).then(response => {});
        },
        activeLayers() {
            this.layersActive = !this.layersActive;
            // if (this.layersActive) {
            //
            // }
            // this.tabhide = !this.tabhide
        },
        exportXls() {
            this.loader = true;
            httpService.get("/plano/" + this.$route.params.id + "/export-excel").then(res => {
                //                    console.log(res, '======')sss
                this.loader = false;
                if (res.code === 400) {
                    this.dialogError(res.message);
                } else {
                    let url = Globals.getBaseUrl() + res.path;
                    window.open(url);
                }
            });
        },
        exportPdf(compression) {
            this.compression = compression;
            if (this.load) this.displayViewPdf = true;
        },
        getModules() {
            let modules = [];
            let groups = this.groups;
            groups.forEach(group => {
                group.modules.forEach(module => {
                    modules.push(module);
                });
            });

            return modules;
        },
        getDataModuleSelected() {
            let mods = this.modulesSelected;
            let datas = [];
            let data;
            mods.forEach(elt => {
                data = d3.select(elt).data()[0];
                datas.push(data);
            });
            return datas;
        },
        addAccessory(accessory) {
            this.accessories.push(accessory);
        },
        addAccessorySelected(accessory) {
            this.accessoriesSelected.push(accessory);
        },
        deleteAccessorySelected(accessory) {
            let accessories = this.accessoriesSelected;

            if (accessories.includes(accessory)) {
                accessories.splice(accessories.indexOf(accessory), 1);
            }
        },
        deleteAccessory(accessory) {
            let accessories = this.accessories;
            if (accessories.includes(accessory)) {
                accessories.splice(accessories.indexOf(accessory), 1);
            }
        },
        cleanSelectedAccessories() {
            this.accessoriesSelected = [];
        },
        addSelectModule(mod) {
            this.modulesSelected.push(mod);
        },
        cleanSelectedModules() {
            this.modulesSelected = [];
        },
        deleteSelectModule(mod) {
            let modules = this.modulesSelected;

            if (modules.includes(mod)) {
                modules.splice(modules.indexOf(mod), 1);
            }
        },
        loadListeners() {
            let osMac = navigator.appVersion.toUpperCase().includes("MACINTOSH");

            d3.select("g#contentPlanoMain").on("mousedown", () => {
                if (d3.event.which === 1) {
                    this.deselectAll();
                }
            });

            document.body.addEventListener("wheel", e => {
                if (e.ctrlKey) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            document.body.addEventListener("keydown", e => {
                if (osMac) {
                    if (e.keyCode === 91) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.singleSelection = false;
                    }
                } else {
                    if (e.keyCode === 17) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.singleSelection = false;
                    }
                }

                if (e.keyCode === 18) {
                    e.stopPropagation();
                    e.preventDefault();
                    if (this.modePan === false) {
                        this.panAction();
                    }
                }
            });
            document.body.addEventListener("keyup", e => {
                if (osMac) {
                    if (e.keyCode === 91) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.singleSelection = true;
                    }
                } else {
                    if (e.keyCode === 17) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.singleSelection = true;
                    }
                }

                if (e.keyCode === 18) {
                    this.selectionAction();
                }
            });
            d3.select("svg#builder").on("contextmenu", this.contextMenu);
        },
        loadDataPlano(data) {
            let heightExt = 0;
            let widthExt = 0;
            let base = 0;
            let front = 0;
            let widthInt = 0;
            let heightInt = 0;
            let horiPitch = 0;
            let vertPitch = 0;
            let horiPitchRepeat = 0;
            let vertPitchRepeat = 0;
            let blocks = {};
            let blockWitdh;
            let segWidth = 0;
            let segHeight = 0;

            this.groups = data.groups ? data.groups : [];
            this.accessories = data.accessories ? data.accessories : [];

            if (data.plano) {
                heightExt = data.plano.heightExternal;
                widthExt = data.plano.widthExternal;
                base = data.plano.base;
                front = data.plano.front;
                widthInt = data.plano.widthInternal;
                heightInt = data.plano.heightInternal;
                horiPitch = data.plano.steps[1].length;
                vertPitch = data.plano.steps[0].length;
                horiPitchRepeat = data.plano.steps[1].repeat;
                vertPitchRepeat = data.plano.steps[0].repeat;
                blocks = data.plano.blocks;
                blockWitdh = blocks[0] ? blocks[0].length : 0;
                segWidth = data.plano.segmentation_bar_width;
                segHeight = data.plano.segmentation_bar_height;
            } else {
                heightExt = data.heightExternal;
                widthExt = data.widthExternal;
                base = data.base;
                front = data.front;
                widthInt = data.widthInternal;
                heightInt = data.heightInternal;
                horiPitch = data.steps ? data.steps[1].length : 0;
                vertPitch = data.steps ? data.steps[0].length : 0;
                horiPitchRepeat = data.steps ? data.steps[1].repeat : 0;
                vertPitchRepeat = data.steps ? data.steps[0].repeat : 0;
                blocks = data.blocks;
                if (blocks) {
                    blockWitdh = blocks[0] ? blocks[0].length : 0;
                    segWidth = data.segmentation_bar_width;
                    segHeight = data.segmentation_bar_height;
                }
            }

            let dataPlano = {
                heightExt,
                widthExt,
                base,
                front,
                widthInt,
                heightInt,
                horiPitch,
                vertPitch,
                horiPitchRepeat,
                vertPitchRepeat,
                blocks,
                blockWitdh,
                segWidth,
                segHeight
            };

            this.planoData = dataPlano;
        },
        getDataPlano() {
            return this.planoData;
        },
        drawplano() {
            let dataPlano = this.getDataPlano();
            //                console.log(dataPlano)
            let meubleHeightExt = dataPlano.heightExt;
            let meubleWidthExt = dataPlano.widthExt;
            let base = dataPlano.base;
            let front = dataPlano.front;
            let meubleWidthInt = dataPlano.widthInt;
            let meubleHeightInt = dataPlano.heightInt;
            let horiPitch = dataPlano.horiPitch;
            let vertPitch = dataPlano.vertPitch;
            let horiPitchRepeat = dataPlano.horiPitchRepeat;
            let vertPitchRepeat = dataPlano.vertPitchRepeat;
            //                let blocks = {}
            let blockWitdh = dataPlano.blockWitdh;
            let segWidth = dataPlano.segWidth;
            let segHeight = dataPlano.segHeight;

            segHeight = !segHeight ? 0 : segHeight;

            let svg = d3.select("svg");
            svg.node().innerHTML = "";
            this.svg = svg.append("g").call(this.zoom());
            this.gMain = this.svg
                .append("g")
                .attr("id", "contentPlanoMain")
                .data([{ transform: null }])
                .raise();

            // this.gZoom = svg.append("g");

            let g = this.gMain.append("g").attr("id", "planoMeuble");
            g.append("rect")
                .attr("id", "meuble")
                .attr("width", meubleWidthExt)
                .attr("height", meubleHeightExt)
                .attr("x", 0)
                .attr("y", 0)
                .attr("stroke", "black")
                .attr("fill", "white");
            g.append("line")
                .attr("id", "front")
                .attr("x1", 0)
                .attr("y1", front)
                .attr("x2", meubleWidthExt)
                .attr("y2", front)
                .attr("stroke", "black")
                .attr("fill", "white");
            g.append("line")
                .attr("id", "base")
                .attr("x1", 0)
                .attr("y1", meubleHeightExt - base)
                .attr("y2", meubleHeightExt - base)
                .attr("x2", meubleWidthExt)
                .attr("stroke", "black");
            let widthCenter = (meubleWidthExt - meubleWidthInt) / 2;
            let heightCenter = (meubleHeightExt - (front + base) - meubleHeightInt) / 2;
            let gContainer = this.gMain
                .append("g")
                .data([{ x: widthCenter, y: heightCenter }])
                .attr("id", "meubleInt")
                .attr("transform", "translate(" + widthCenter + "," + heightCenter + ")");

            gContainer
                .append("rect")
                .attr("id", "rectInt")
                .attr("width", meubleWidthInt)
                .attr("height", meubleHeightInt)
                .attr("stroke", "black")
                .attr("x", 0)
                .attr("y", front)
                .attr("fill", "white");
            // barre de segmentation
            if (segHeight !== 0) {
                gContainer
                    .append("rect")
                    .attr("id", "segmentation")
                    .attr("x", 0)
                    .attr("y", front)
                    .attr("width", segWidth)
                    .attr("height", segHeight)
                    .attr("fill", "#343434");
                // création de la grille

                let data2 = [];
                for (let j in d3.range(0, horiPitchRepeat)) {
                    j = parseInt(j, 10);
                    data2[j] = { i: j, x: 0, y: front, posX: 0, posY: 0, width: 0, height: segHeight };
                }
                let repXSeg = 0;

                gContainer
                    .selectAll(".grid-seg")
                    .raise()
                    .data(data2)
                    .enter()
                    .append("g")
                    .raise()
                    .attr("class", "grid-seg")
                    .append("rect")
                    .raise()
                    .attr("class", "rect-grid-seg")
                    .attr("width", d => {
                        d.width = parseFloat(horiPitch);
                        return horiPitch;
                    })
                    .attr("height", segHeight)
                    // .attr('stroke', 'black')
                    .attr("fill", "white")
                    .attr("fill-opacity", 0)
                    .attr("opacity", 0)
                    .attr("x", d => {
                        rx = repXSeg * horiPitch;
                        d.x = rx;
                        d.posX = repXSeg;
                        repXSeg++;
                        return d.x;
                    })
                    .attr("y", front);
            }

            let count = vertPitchRepeat * horiPitchRepeat;

            let repX = 0;
            let repY = 0;
            let rx = 0;
            let ry = 0;
            let data = [];
            for (let j in d3.range(0, count)) {
                j = parseInt(j, 10);
                data[j] = { i: j, x: 0, y: 0, posX: 0, posY: 0, width: 0, height: 0 };
            }

            gContainer
                .selectAll(".content-module")
                .raise()
                .data(data)
                .enter()
                .append("g")
                .raise()
                .attr("class", "content-module")
                .append("rect")
                .raise()
                .attr("class", "rect-content-module")
                .attr("width", d => {
                    d.width = parseFloat(horiPitch);
                    return horiPitch;
                })
                .attr("height", d => {
                    d.height = parseFloat(vertPitch);
                    return vertPitch;
                })
                .attr("stroke", "black")
                .attr("fill", "white")
                .attr("fill-opacity", 1)
                .attr("opacity", 1)
                .attr("x", d => {
                    if (d.i % horiPitchRepeat === 0) repX = 0;
                    else repX++;
                    rx = repX * horiPitch;
                    // rx = (window.innerWidth / 4) + (repX * horiPitch)
                    d.x = rx;
                    d.posX = repX;
                    return rx;
                })
                .attr("y", d => {
                    if (d.i === 0) repY = 0;
                    else if (d.i % horiPitchRepeat === 0) repY++;
                    ry = front + segHeight + repY * vertPitch;
                    d.y = ry;
                    d.posY = repY;
                    return ry;
                });

            let bb = this.gMain.node().getBBox();
            svg.attr("viewBox", "0 0 " + bb.width + " " + bb.height);
            this.$emit("listenerDrag");
            let bbContentPlanoMod = gContainer.node().getBBox();
            let nbBlock;
            if (blockWitdh === 0) {
                nbBlock = 1;
                blockWitdh = bbContentPlanoMod.width;
            } else {
                nbBlock = bbContentPlanoMod.width / blockWitdh;
            }
            gContainer
                .selectAll(".blocks")
                .data(d3.range(1, nbBlock))
                .enter()
                .append("line")
                .attr("stroke-width", 3)
                .raise()
                .attr("class", "blocks")
                .attr("x1", d => {
                    return d * blockWitdh;
                })
                .attr("x2", d => {
                    return d * blockWitdh;
                })
                .attr("y1", bbContentPlanoMod.y)
                .attr("y2", bbContentPlanoMod.height + front)
                .attr("stroke", "red");
        },

        // loadModules () {
        //     let groups = this.groups
        //     let groupsElts = {}
        //     let g
        //     let container = d3.select('#meubleInt').raise()
        //     groups.forEach((group) => {
        //         g = container.append('g')
        //
        //         g.data([{
        //             groupId: group.id,
        //             selected: false
        //         }])
        //         groupsElts[group.id] = g
        //     })
        //     let promises = []
        //     groups.forEach((group) => {
        //         group.modules.forEach((module) => {
        //             // let idModule = parseInt(module.id, 10)
        //             promises.push(this.loadModule(module, groupsElts))
        //         })
        //     })
        //
        //     Promise.all(promises).then(() => {
        //         this.loader = false
        //         console.timeEnd('plano')
        //     })
        //
        // },
        loadModules() {
            this.loadModulesNew();
            // this.loadModulesOld()
        },

        canModifConfigModule(groupModule, itemGroups) {
            //                let group
            let can = false;
            let index = itemGroups.findIndex(g => {
                return g.tester === groupModule.tester;
            });
            if (index === -1) {
                can = true;
            } else {
                let group = itemGroups.find(g => {
                    return g.tester === groupModule.tester;
                });

                if (group.modules.length === groupModule.modules.length) {
                    let mod, index2;
                    for (let i = 0, l = groupModule.modules.length; i < l; i++) {
                        mod = groupModule.modules[i];
                        index2 = group.modules.findIndex(m => {
                            return m === mod;
                        });
                        if (index2 === -1) {
                            can = true;
                            break;
                        }
                    }
                }
            }

            return can;
        },
        loadModule(mod, groupsElts) {
            return this.createModule(mod).then(res => {
                if (res) {
                    // console.log('=================================================')
                    let gElt = groupsElts[res.module.groupId];
                    gElt.raise();
                    gElt.node().append(res.elt);
                    this.loadConfigModule(res.elt, res.module);
                    this.loadListnerModule(res.elt);
                    d3.select("#meubleInt")
                        .selectAll("rect.accessory-frame")
                        .raise();
                    return true;
                } else {
                    return false;
                } //
            });
        },
        reloadAccessoriesSeg() {
            let accessories = this.getAccessories.filter(accessory => {
                return parseInt(accessory.subtype, 10) === 31;
            });
            let segElt, parent;
            accessories.forEach(accessory => {
                segElt = document.querySelector("rect#" + accessory.UUID);
                parent = segElt.parentNode;
                d3.select(parent)
                    .select("text")
                    .text(this.getTranslate(accessory.text));
            });
        },

        loadAccessories() {
            let accessories = this.getAccessories;
            accessories.forEach(accessory => {
                let subtype = accessory.subtype;
                let rect =
                    subtype === "40"
                        ? this.getRectByPosition(accessory.posX, accessory.posY)
                        : this.getRectSegmentationPosition(accessory.posX, accessory.posY);
                if (rect === null) return;
                let rectData = d3.select(rect).data()[0];
                if (subtype === "40") {
                    let frame = d3
                        .select("#meubleInt")
                        .append("rect")
                        .raise()
                        .data([accessory])
                        .attr("width", rectData.width * accessory.size.width)
                        .attr("height", rectData.height * accessory.size.height)
                        .attr("stroke", accessory.color)
                        .attr("stroke-width", 10)
                        .attr("fill-opacity", 0)
                        .attr("id", accessory.UUID)
                        .attr("x", rectData.x)
                        .attr("y", rectData.y)
                        .attr("class", "accessory-frame");
                    // this.addAccessory(dataMod)
                    this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                } else if (subtype === "31") {
                    let g = d3.select("#meubleInt").append("g");
                    let widthSeg = rectData.width * accessory.size.width;
                    let frame = g
                        .append("rect")
                        .raise()
                        .data([accessory])
                        .attr("width", widthSeg)
                        .attr("height", rectData.height * accessory.size.height)
                        .attr("stroke", accessory.color)
                        .attr("stroke-width", 8)
                        .attr("fill", accessory.color)
                        .attr("id", accessory.UUID)
                        .attr("x", rectData.x)
                        .attr("y", rectData.y)
                        .attr("class", "accessory-segmentation");
                    // console.log(data)
                    let text = g
                        .append("text")
                        .raise()
                        .attr("class", "text-segmentation")
                        .text(this.getTranslate(accessory.text))
                        .attr("x", rectData.x)
                        .attr("y", rectData.y)
                        // .attr('width', widthMod)
                        // .attr('height', heightMod)
                        .attr("dy", 40)
                        // .attr('dx', 20)
                        .attr("fill", "white")
                        .style("font-size", rectData.height * accessory.size.height);

                    let bbText = text.node().getBBox();
                    let dx = widthSeg / 2 - bbText.width / 2;
                    text.attr("dx", dx);
                    this.drag(frame, this.dragStartAccessory, this.dragAccessory, this.dragEndAccessory);
                }
            });
        },
        test() {
            console.log(this.groups, "==== groups ===");
            console.log(this.getModules(), "==== modules ===");
            console.log(this.accessories, "==== accessories ===");
            console.log(this.getJsonPlanoSimple(), "====== json simple =====");
            console.log(d3.select("g#meubleInt").selectAll("svg.module_snap"), "==== elt svg ====");
        },
        activeTab(tabId) {
            let active = false;
            // console.log(tabId)
            if (tabId === "hide") {
                active = this.tabhide;
            } else {
                active = this.tabSelected === tabId;
            }

            return active;
        },
        views(tabId, event) {
            this.tabId = tabId;

            if (tabId === "hide") {
                let elt = event.target;
                let bb = elt.getBoundingClientRect();
                // console.log(bb)
                this.layerX = bb.x + "px";
                this.layerY = bb.y - 70 + "px";
                this.tabhide = !this.tabhide;
            } else this.tabSelected = tabId;
        },
        viewsModule(view, active) {
            let make = true;
            if (view === "modules") {
                let modulesD3 = d3.select("svg g#meubleInt").selectAll("svg.module_snap");
                modulesD3.attr("visibility", !active ? "hidden" : "visible");
                make = !active;
            }

            if (make) {
                if (view === "iconscolors") {
                    if (active) {
                        this.addViewActive("color");
                    } else {
                        this.removeViewActive("color");
                    }
                }
                console.log(view, active);
                if (view === "reference") {
                    if (active) {
                        this.addViewActive("ref");
                    } else {
                        this.removeViewActive("ref");
                    }
                }

                let modules = this.getModules();
                modules.forEach(module => {
                    //                    console.log(module)
                    let elt = document.getElementById(module.UUID);
                    this.loadColor(elt, module);
                });
            }
        },
        viewTicketstrip() {
            this.viewticketstrip = !this.viewticketstrip;
            // this.visibilityLayerIconMenu('ticketstrip', this.viewticketstrip)
            if (this.viewticketstrip) {
                this.addViewActive("ticketstrip");
            } else {
                this.removeViewActive("ticketstrip");
            }
            //
            this.getModules().forEach(data => {
                this.loadTicketStripsByData(data, false);
            });
        },
        viewRealistic() {
            this.realistic = !this.realistic;
            let realistic = this.realistic;
            let reals = d3.select("#meubleInt").selectAll(".img-realistic");
            let groups = this.groups;
            let group;
            let module, modules;
            let url;
            // this.visibilityLayerIconMenu('realistic', realistic)
            if (realistic) {
                //                    if (reals.size() === 0) {
                for (let i = 0, l = groups.length; i < l; i++) {
                    group = groups[i];
                    modules = group.modules;
                    for (let j in modules) {
                        module = modules[j];
                        if (module.srcreal) {
                            let eltId = "realistic_" + module.UUID;
                            let img = d3.select("#" + eltId);
                            let x = module.posX;
                            let y = module.posY;
                            // console.log(x, y)
                            let rect = this.getRectByPosition(x, y);
                            if (rect === null) continue;
                            let rectData = d3.select(rect).data()[0];
                            if (img.size() === 0) {
                                // console.log(rect, rectData)
                                url = this.getCleanUrl(module.srcreal);
                                d3.select("#meubleInt")
                                    .append("svg:image")
                                    .raise()
                                    .attr("id", eltId)
                                    .attr("class", "img-realistic")
                                    .attr("x", rectData.x)
                                    .attr("y", rectData.y)
                                    .attr("width", rectData.width * module.size.width)
                                    .attr("height", rectData.height * module.size.height)
                                    .attr("xlink:href", url);
                            } else {
                                img.attr("x", rectData.x).attr("y", rectData.y);
                            }

                            img.raise();
                        }
                    }
                }
                reals.attr("visibility", "visible");
                d3.select("#meubleInt")
                    .selectAll(".accessory-frame")
                    .raise();
            } else {
                // console.log(reals)
                reals.attr("visibility", "hidden");
                // reals.raise()
            }
        },
        // action des button sur le coté gauche
        selectionAction() {
            d3.select("g#content-pan").attr("visibility", "hidden");
            //                this.upBuilderField('selection', true)
            this.modeSelection = true;
            this.modePan = false;
            // this.upBuilderField('pan', false)
        },
        panAction() {
            let g = this.svg.select("g#content-pan");
            if (g.size() === 0) {
                g = this.svg
                    .append("g")
                    .attr("id", "content-pan")
                    .raise();

                //                    if ()
                g.append("rect")
                    .attr("fill-opacity", 0)
                    .attr("width", 40000)
                    .attr("height", 40000)
                    .attr("x", -20000)
                    .attr("y", -20000);
            } else {
                let bbg = g.node().getBBox();
                if (bbg.height === 0 && bbg.width === 0) {
                    g.select("rect")
                        .attr("fill-opacity", 0)
                        .attr("width", 40000)
                        .attr("height", 40000)
                        .attr("x", -20000)
                        .attr("y", -20000);
                }
            }

            g.attr("visibility", "visible");

            this.modePan = true;
            this.modeSelection = false;
        },
        zoom: function(force = false) {
            this.zoomEvent = d3
                .zoom()
                .scaleExtent([1, 20])
                .on("zoom", () => {
                    if (force || this.modePan) {
                        let transform = d3.event.transform;
                        this.gMain.attr("transform", d => {
                            d.transform = transform;
                            return transform;
                        });
                        this.kZoom = transform.k;
                    }
                });

            return this.zoomEvent;
        },
        zoomIn() {
            let zoom = this.zoom(true);
            this.kZoom += 0.2;
            zoom.scaleTo(this.svg, this.kZoom);
        },
        zoomOut() {
            let zoom = this.zoom(true);
            this.kZoom -= 0.2;
            if (this.kZoom < 1) this.kZoom = 1;
            zoom.scaleTo(this.svg, this.kZoom);
        },
        zoomModuleAction() {
            this.zoomModule = !this.zoomModule;
            // contentPlanoMain
            //                this.upBuilderField('zoommodule', this.zoomModule)
            if (this.modeSelection && this.modulesSelected.length > 0 && this.zoomModule) {
                let modElt = this.modulesSelected[0];
                let gParent = modElt.parentNode;
                let bb = gParent.getBBox();
                let gMeubleIntData = d3.select("g#meubleInt").data()[0];
                d3.select("#contentPlanoMain").attr("transform", d => {
                    if (d.transform !== null) {
                        d.transform.k = 1;
                        d.transform.x = 0;
                        d.transform.y = 0;
                    }
                    return d.transform;
                });
                d3.select("svg#builder").attr(
                    "viewBox",
                    bb.x + gMeubleIntData.x + " " + (bb.y + gMeubleIntData.y) + " " + bb.width + " " + bb.height
                );
            } else {
                this.zoomModule = false;
                let contentPlanoMain = d3.select("#contentPlanoMain").node();
                let bb = contentPlanoMain.getBBox();
                d3.select("svg#builder").attr("viewBox", "0 0 " + bb.width + " " + bb.height);
            }
        },
        planoPosInitMousedown() {
            this.posInit = !this.posInit;
            this.zoomModule = false;
        },
        planoPosInit() {
            d3.select("#contentPlanoMain").attr("transform", d => {
                if (d.transform === null) return null;
                d.transform.k = 1;
                d.transform.x = 0;
                d.transform.y = 0;
                this.kZoom = 1;
                return d.transform;
            });
            let contentPlanoMain = d3.select("#contentPlanoMain").node();
            let bb = contentPlanoMain.getBBox();
            d3.select("svg#builder").attr("viewBox", "0 0 " + bb.width + " " + bb.height);
            this.posInit = false;
        },
        // action des bouton du bas
        editModule() {
            this.tabhide = false;
            this.destroyMenu();
            //                if (!this.tabhide) return
            if (this.modulesSelected.length === 0) {
                Vue.toast("Attention: il faut séléctionner aux moins un module", {
                    id: "my-toast-error",
                    className: ["toast-warning", "flexContainer"],
                    horizontalPosition: "right",
                    verticalPosition: "bottom",
                    mode: "queue"
                });
                //                    alert('Attention: il faut séléctionner un module')
                return;
            } else {
                // alert('Travailler avec les tableaux au lieu d\'un module a l\'editon')
                let group = this.groupSelected;
                let datas = [];
                if (group !== null) {
                    datas = group.modules;
                } else {
                    datas = this.getDataModuleSelected();
                    if (datas.length > 1) {
                        Vue.toast("Attention: Pour sélectionner plusieurs modules il faut les groupés", {
                            id: "my-toast-error",
                            className: ["toast-warning", "flexContainer"],
                            horizontalPosition: "right",
                            verticalPosition: "bottom",
                            mode: "queue"
                        });
                        return;
                    }
                }

                let ids = [];
                let d;
                let valid = true;
                for (let i = 0, l = datas.length; i < l; i++) {
                    d = datas[i];
                    if (ids.includes(d.id) === false && i > 0) {
                        valid = false;
                        break;
                    }
                    ids.push(d.id);
                }
                //                    console.log(datas, valid)
                if (valid) {
                    let data = datas[0];
                    this.id = data.id;
                    this.$store.dispatch("plano/data/getRelatedProducts", { id: this.id }).then(() => {
                        this.displayMenuShades = true;
                    });
                    this.setModulesEdit(datas);
                    this.setUpdatePlano(false);
                    this.setMode("module");
                } else {
                    Vue.toast("Attention: on ne peut pas éditer plusieurs modules différent.", {
                        id: "my-toast-error",
                        className: ["toast-warning", "flexContainer"],
                        horizontalPosition: "right",
                        verticalPosition: "bottom",
                        mode: "queue"
                    });
                }
            }
            //                if (this.modulesSelected.length > 1) {
            //
            //                } else {
            // //                    this.displayModule = true

            // //                    this.deselectAll()
            // //                    this.deleteAllModulesElt()
            // //                    d3.select('svg#builder').select('g#planoMeuble').remove()
            // //                    d3.select('svg#builder').select('g#meubleInt').remove()
            //                }
        },
        duplicate() {
            let modules = this.modulesSelected;

            let valid = this.isGroupSelected();

            if (valid) {
                this.copies(modules);
                this.setUpdatePlano(false);
            }
        },
        /**
         * @param group
         * @description supprimer un goup dans groups des data
         */
        deleteGroup(group) {
            let groups = this.groups;
            if (groups.includes(group)) {
                groups.splice(groups.indexOf(group), 1);
            }
        },
        addGroup() {
            if (!this.canCreateGroup()) {
                this.$swal({
                    title: this.$t("planobuilder.warning"),
                    text: "Attention on ne peut pas créer un group car les modules ne sont pas rattachés",
                    type: "warning",
                    //                                showCancelButton: true,
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: "Ok"
                    // cancelButtonText: 'Non'
                });
                return;
            }
            if (this.countSelectModules <= 1) return;
            let modules = this.modulesSelected;
            let groupSelect = this.groupSelected;
            let eltG;
            let gAtRemove;
            let dMod;
            if (groupSelect !== null) {
                for (let i = 0, l = modules.length; i < l; i++) {
                    dMod = d3.select(modules[i]).data()[0];
                    if (dMod.groupId === groupSelect.id) {
                        eltG = modules[i].parentNode;
                        break;
                    }
                }

                let gr;
                //                    let m
                let d;
                modules.forEach(mod => {
                    d = d3.select(mod).data()[0];
                    gr = this.getGroupByModule(d);

                    if (gr !== groupSelect) {
                        this.deleteGroup(gr);
                        d.groupId = groupSelect.id;
                        gAtRemove = mod.parentNode;
                        eltG.append(mod);
                        gAtRemove.parentNode.removeChild(gAtRemove);
                        d3.select(mod).datum(d);
                        groupSelect.modules.push(d);
                    }
                });
                this.deselectAll();
            } else {
                let groups = this.groups;
                let data = null;

                let modulesInclude = [];
                groups.forEach(g => {
                    modulesInclude = modulesInclude.concat(g.modules);
                });
                let moduleInclude = null;

                let valid = true;
                let svg;
                let gr;
                let eltM = modules[0];
                eltG = eltM.parentNode;
                let modDataFirst = d3.select(eltM).data()[0];
                let groupMain = this.getGroupByModule(modDataFirst);

                for (let j = 0; j < modules.length; j++) {
                    svg = modules[j];
                    data = d3.select(svg).data()[0];
                    gr = this.getGroupByModule(data);
                    for (let i = 0; i < modulesInclude.length; i++) {
                        moduleInclude = modulesInclude[i];
                        if (gr.length > 1 && moduleInclude.groupId === data.groupId) {
                            valid = false;
                            break;
                        }
                    }

                    if (valid === true) {
                        data.groupId = groupMain.id;

                        d3.select(svg).datum(data);
                        if (groupMain.id !== gr.id) {
                            this.deleteGroup(gr);
                            gAtRemove = svg.parentNode;
                            eltG.append(svg);
                            gAtRemove.parentNode.removeChild(gAtRemove);
                            groupMain.modules.push(data);
                        }
                    } else {
                        alert("On ne peut pas ajouter se groupe car un des module a déjà une appartenance à un groupe");
                        break;
                    }
                }

                if (valid) {
                    this.deselectAll();
                    this.setUpdatePlano(false);
                }
            }
        },

        removeGroupAll() {
            this.ungroupAll = true;
            let groups = this.groups.filter(gr => {
                return gr.modules.length > 1;
            });

            // console.log(groups, '====')
            groups.forEach(group => {
                this.ungroup(group);
            });
        },
        removeGroup() {
            let groupSelect = this.groupSelected;
            if (groupSelect === null) return;
            this.setUpdatePlano(false);
            this.ungroup(groupSelect);
        },
        ungroup(group) {
            let modules = group.modules;
            let eltMod;
            let nodeParentRemove = d3.select("svg#" + modules[0].UUID).node().parentNode;
            let plano = d3.select("#meubleInt");
            let groupId;
            let g;
            modules.forEach(module => {
                eltMod = document.querySelector("#" + module.UUID);
                g = plano.append("g");
                g.node().append(eltMod);
                groupId = this.addGroupAuto(eltMod);
                g.data([{ groupId: groupId, selected: false }]);
            });
            this.deselectAll();
            this.deleteGroup(group);
            nodeParentRemove.parentNode.removeChild(nodeParentRemove);
        },
        addFav() {
            let valid = this.isGroupSelected();
            if (valid) {
                this.setUpdatePlano(false);
                this.setShowModalFavorite(true);
                let objectFav = this.createModuleForFavAndScratch();
                this.addFavorite(objectFav);
            }
        },
        addScratch() {
            let valid = this.isGroupSelected();
            if (valid) {
                let objScratchPad = this.createModuleForFavAndScratch(true);
                // console.log(objScratchPad)
                this.addScratchPad(objScratchPad);
                this.scratch = true;
                Vue.toast("ENREGISTREMENT DANS SCRATCHPAD REUSSI", {
                    id: "my-toast",
                    className: ["my-toast", "toast-warning", "flexContainer"],
                    horizontalPosition: "right",
                    verticalPosition: "bottom",
                    mode: "queue"
                });
                if (this.canDisplayMenuScratch) {
                    //                        console.log('emit')
                    bus.$emit("reload_scratchpad");
                } else {
                    this.setDisplayMenuScratch(true);
                }
                this.setUpdatePlano(false);
            }
        },
        deleteModuleAction() {
            let modules = this.modulesSelected;
            let group;
            let modData;
            let groups = {};
            let gEls = [];
            let imgsReal = [];
            let gElt;
            if (modules.length > 0) {
                modules.forEach(mod => {
                    modData = d3.select(mod).data()[0];
                    group = this.getGroupByModule(modData);
                    if (!groups[group.id]) {
                        groups[group.id] = group;
                    }

                    imgsReal.push("realistic_" + modData.UUID);

                    gElt = mod.parentNode;
                    if (gEls.includes(gElt) === false) {
                        gEls.push(gElt);
                    }
                });
                Object.values(groups).forEach(gr => {
                    this.deleteGroup(gr);
                });

                gEls.forEach(el => {
                    el.parentNode.removeChild(el);
                });

                imgsReal.forEach(imgReal => {
                    d3.select("#" + imgReal).remove();
                });
                this.setUpdatePlano(false);
            }

            //                let accessories = this.getAccessories
            let accessoriesSelected = this.getAccessoriesSelected;
            //                let eltD3
            accessoriesSelected.forEach(accessory => {
                if (accessory.subtype === "31") {
                    let rect = d3.select("rect#" + accessory.UUID).node();
                    let parent = rect.parentNode;
                    d3.select(parent).remove();
                } else {
                    d3.select("rect#" + accessory.UUID).remove();
                }
                this.deleteAccessory(accessory);
            });

            this.deselectAll();
        },
        createModuleForFavAndScratch(scratch = false) {
            let modules = this.modulesSelected;
            let modEltCop;
            let dataMod;
            let dataModCop;
            let imgsReal = [];

            // console.log(modulesData)
            // let test = true
            // if (test) return

            modules.sort((mod1, mod2) => {
                // console.log(parseInt(mod1.getAttribute('x'), 10) + ' ' + parseInt(mod2.getAttribute('x'), 10))
                return (
                    parseInt(mod1.getAttribute("y"), 10) -
                    parseInt(mod2.getAttribute("y"), 10) +
                    parseInt(mod1.getAttribute("x"), 10) -
                    parseInt(mod2.getAttribute("x"), 10)
                );
            });

            // modules.sort((mod1, mod2) => {
            //     return parseInt(mod1.getAttribute('x'), 10) - parseInt(mod2.getAttribute('x'), 10)
            // })

            let groupElt = d3.select(modules[0]).node().parentNode;
            let bbGroup = groupElt.getBBox();

            let xmlns = "http://www.w3.org/2000/svg";
            let boxWidth = 195;
            let boxHeight = 195;

            var svgElem = document.createElementNS(xmlns, "svg");
            svgElem.setAttributeNS(null, "width", boxWidth);
            svgElem.setAttributeNS(null, "height", boxHeight);

            svgElem.style.width = boxWidth + "px";
            svgElem.style.height = boxHeight + "px";
            let g = d3
                .select(svgElem)
                .attr("class", "fav-modules size1of2")
                .attr("viewBox", "0 0 " + bbGroup.width + " " + bbGroup.height)
                .append("g")
                .node();

            d3.select(svgElem).data([{ countModules: modules.length }]);
            let x, y, posX, posY;

            let xOrigin = 0;
            let yOrigin = 0;
            let posXOrigin = 0;
            let posYOrigin = 0;

            let object = {
                size: { width: 0, height: 0 },
                svg: svgElem,
                modules: []
            };
            let sizeWidth = 0;
            let sizeHeight = 0;
            let uuid;

            let modulesData = this.getDataModuleSelected();

            modulesData.forEach((modData, i) => {
                if (i === 0) {
                    xOrigin = modData.x;
                    yOrigin = modData.y;
                    posXOrigin = modData.posX;
                    posYOrigin = modData.posY;
                } else {
                    if (xOrigin > modData.x) xOrigin = modData.x;
                    if (yOrigin > modData.y) yOrigin = modData.y;
                    if (posXOrigin > modData.posX) posXOrigin = modData.posX;
                    if (posYOrigin > modData.posY) posYOrigin = modData.posY;
                }
            });
            // console.log(xOrigin, posXOrigin, yOrigin, posYOrigin, '=== origin')
            modules.forEach((mod, i) => {
                uuid = "elt_" + this.UUID();
                modEltCop = mod.cloneNode(true);
                modEltCop.id = uuid;
                dataMod = d3.select(mod).data()[0];
                dataModCop = this.assign(dataMod);
                imgsReal.push("#realistic_" + dataMod.UUID);
                // console.log(dataModCop, '===========================================')

                x = dataModCop.x - xOrigin;
                y = dataModCop.y - yOrigin;
                posX = dataModCop.posX - posXOrigin;
                posY = dataModCop.posY - posYOrigin;

                if (posX >= sizeWidth) {
                    sizeWidth = posX;
                    if (dataModCop.size.width > 1) {
                        sizeWidth = posX + (dataModCop.size.width - 1);
                    }
                }

                if (posY >= sizeHeight) {
                    sizeHeight = posY;
                    if (dataModCop.size.height > 1) {
                        sizeHeight = posY + (dataModCop.size.height - 1);
                    }
                }
                // console.log(posXOrigin, posX)
                dataModCop.x = x;
                dataModCop.y = y;
                dataModCop.posX = posX;
                dataModCop.posY = posY;
                dataModCop.groupId = null;
                dataModCop.UUID = uuid;
                dataModCop.selected = false;
                d3.select(modEltCop).data([dataModCop]);
                // object.modules.push({svg: modEltCop, data: this.assign(dataModCop)})
                object.modules.push({ data: this.assign(dataModCop) });
                d3.select(modEltCop)
                    .attr("x", x)
                    .attr("y", y)
                    .style("width", modEltCop.getAttribute("width") + "px")
                    .style("height", modEltCop.getAttribute("height") + "px");
                //                            .select('svg').remove()
                d3.select(modEltCop)
                    .select("svg")
                    .attr("visibility", "hidden");
                // console.log(modEltCop)
                d3.select(modEltCop)
                    .select("g#TICKET_STRIPS")
                    .selectAll("image.image-ticket-strip")
                    .remove();
                g.append(modEltCop);
            });
            object.size.width = sizeWidth + 1;
            object.size.height = sizeHeight + 1;

            svgElem.addEventListener("mousedown", e => {
                this.copyFav(e, object, svgElem);
            });
            object.isScratchpad = scratch;

            if (scratch === true) {
                let dataModDelete;
                let groupDelete;
                let modDelete = modules[0];
                dataModDelete = d3.select(modDelete).data()[0];

                imgsReal.forEach(imgReal => {
                    d3.select(imgReal).remove();
                });

                groupDelete = this.getGroupByModule(dataModDelete);
                this.deleteGroup(groupDelete);

                //                    modules.forEach((modD) => {
                //                        this.deleteModule(modD)
                //                    })

                let children = groupElt.childNodes;
                children.forEach(child => {
                    groupElt.removeChild(child);
                });
                groupElt.parentNode.removeChild(groupElt);
                this.deselectAll();
            }
            return object;
        },
        copy(event, itemData = null) {
            if (this.load === false) return;
            let item = event.target;

            let contentMenu = document.querySelector("#contentMenu");
            let resultsWrapper = document.querySelector("#resultsWrapper");
            let bbContent = contentMenu.getBoundingClientRect();
            let bbResWra = resultsWrapper.getBoundingClientRect();
            // console.log(bbContent, bbResWra)
            let moduleSize = item.getAttribute("modulesize");
            let type = item.getAttribute("component_type");
            let subtype = item.getAttribute("component_subtype");
            let modSizeWidth = moduleSize ? parseInt(moduleSize.split(",")[0], 10) : 1;
            let modSizeHeight = moduleSize ? parseInt(moduleSize.split(",")[1], 10) : 1;
            let itemCopy = item.cloneNode(true);
            let sizeContentMod = null;
            let isSegmentation = type === "accessory" && subtype === "31";
            let text = "";
            if (isSegmentation) {
                sizeContentMod = this.getSizeContentSegmentation();
                text = item.firstChild.nodeValue;
                itemCopy.style.textAlign = "center";
                // console.log(sizeContentMod)
            } else {
                sizeContentMod = this.getSizeContentModule();
            }
            if (sizeContentMod === null && isSegmentation) {
                alert("Dans se planogramme on ne peut pas mettre de barre de segmentation.");
                return;
            }
            let width = sizeContentMod.width * modSizeWidth;
            let height = sizeContentMod.height * modSizeHeight;
            // console.log(sizeContentMod.height, modSizeHeight, height)
            this.copyItem = true;
            itemCopy.style.height = height + "px";
            itemCopy.style.width = width + "px";
            itemCopy.style.position = "absolute";
            // itemCopy.style.left = x + 'px'
            // itemCopy.style.top = y + 'px'
            itemCopy.style.zIndex = 3000;
            itemCopy.classList.remove("img-fluid");

            itemCopy.id = "copy_" + event.target.id;
            itemCopy.id = "copy_" + item.id;

            let container = document.querySelector("#builderWrapper");
            container.appendChild(itemCopy);
            let diffX = 10;
            let id = item.id.split("item_")[1];
            let h = bbContent.height - bbResWra.height; // bbResWra.y
            let y = event.clientY - h;
            let x = event.clientX - diffX;

            let data = {
                x: x,
                y: y,
                diffX: diffX,
                diffY: height / 4,
                size: { width: modSizeWidth, height: modSizeHeight },
                id: id,
                type: item.getAttribute("component_type"),
                text: text,
                item: itemData
            };
            //                console.log(itemData, id)
            // let v = true
            // if (v) return
            let itemCopD3 = d3
                .select(itemCopy)
                .raise()
                .data([data]);
            if (isSegmentation) {
                this.drag(itemCopD3, null, null, this.endedSeg);
            } else {
                this.drag(itemCopD3);
            }
            let init = {
                bubbles: true,
                cancelable: true,
                view: window
            };
            let evt = new MouseEvent("mousedown", init);

            itemCopy.dispatchEvent(evt);
            //                })
        },
        copyFav(event, objectScratchpad, svg) {
            let item = svg;
            // console.log(objectScratchpad)
            // console.log(item)
            //                let bbContent = item.getBoundingClientRect()
            let y = event.clientY;
            let x = event.clientX;
            let modSizeWidth = objectScratchpad.size.width;
            let modSizeHeight = objectScratchpad.size.height;
            let itemCopy = item.cloneNode(true);
            itemCopy.id = "copy_" + this.UUID();

            let sizeContentMod = this.getSizeContentModule();
            let width = sizeContentMod.width * modSizeWidth;
            let height = sizeContentMod.height * modSizeHeight;
            // console.log(width, sizeContentMod.width, modSizeWidth)
            // console.log(height, sizeContentMod.height, modSizeHeight)
            this.copyItem = true;

            itemCopy.style.height = height + "px";
            itemCopy.style.width = width + "px";
            itemCopy.style.position = "absolute";
            itemCopy.style.zIndex = 3000;

            let mod;
            let dataMod;
            let modules = objectScratchpad.modules;
            let uuid;
            let dataModCop;
            let itemCopyD3 = d3.select(itemCopy);
            itemCopyD3
                .select("g")
                .selectAll("svg.module_snap")
                .each((d, i, cmps) => {
                    uuid = "elt_" + this.UUID();
                    mod = cmps[i];
                    mod.id = uuid;
                    dataMod = modules[i].data;
                    dataModCop = this.assign(dataMod);
                    dataModCop.UUID = uuid;
                    d3.select(mod).data([dataModCop]);
                });

            itemCopy.classList.remove("img-fluid");

            let container = document.querySelector("#builderWrapper");
            container.appendChild(itemCopy);
            // if (this.copyItem) return
            // console.log(event, height, width)
            this.drag(
                d3
                    .select(itemCopy)
                    .raise()
                    .data([
                        {
                            x: x,
                            y: y,
                            size: { width: modSizeWidth, height: modSizeHeight },
                            diffX: 0,
                            diffY: 0
                        }
                    ]),
                null,
                null,
                (d, i, cpms) => {
                    this.dragEndFav(d, i, cpms, objectScratchpad);
                }
            );
            let init = {
                bubbles: true,
                cancelable: true,
                view: window
            };
            let evt = new MouseEvent("mousedown", init);

            itemCopy.dispatchEvent(evt);
        },
        copies(elts) {
            let g = d3
                .select("#meubleInt")
                .append("g")
                .raise();

            let eltCop;
            let data;
            let dataCop;
            let groupId = this.UUID();
            elts.forEach(elt => {
                data = d3.select(elt).data()[0];

                let uuid = "elt_" + this.UUID();

                dataCop = this.assign(data);
                dataCop.groupdId = null;
                dataCop.UUID = uuid;
                dataCop.selected = false;
                eltCop = elt.cloneNode(true);

                g.node().append(eltCop);
                d3.select(eltCop)
                    .data([dataCop])
                    .attr("id", uuid)
                    .attr("x", d => {
                        d.x = parseInt(d.x, 10) + 20;
                        return d.x;
                    })
                    .attr("y", d => {
                        d.y = parseInt(d.y, 10) + 20;
                        return d.y;
                    });
                d3.select(eltCop)
                    .select("svg")
                    .attr("visibility", "hidden");
                this.addGroupAuto(eltCop, groupId);
                g.data([
                    {
                        groupId: groupId,
                        selected: false
                    }
                ]);
                this.drag(d3.select(eltCop), this.dragStartSVG, this.dragSVG, this.dragEndSVG);
            });
        },
        contextMenu(d, i, cmps) {
            if (this.getMode === "plano" && cacheService.get("planoLocked") === "false") {
                d3.event.preventDefault();
                if (this.countSelectComponents === 0) return;
                let items = [
                    { label: { fr: "Editer", en: "Edit" }, action: this.editModule },
                    { label: { fr: "Dupliquer", en: "Duplicate" }, action: this.duplicate },
                    { label: { fr: "Grouper", en: "Group" }, action: this.addGroup },
                    { label: { fr: "Dégrouper", en: "Ungroup" }, action: this.removeGroup },
                    { label: { fr: "Ajouter aux favoris", en: "Add to favorites" }, action: this.addFav },
                    {
                        label: { fr: "Placer dans le scratchpad", en: "Place in the scratchpad" },
                        action: this.addScratch
                    },
                    { label: { fr: "Supprimer", en: "Delete" }, action: this.deleteModuleAction },
                    {
                        label: { fr: "Composant visuel", en: "Visual componant" },
                        action: this.openMenuVisualComponent,
                        event: "mouseover"
                    }
                ];
                this.createMenu(items);
            }
        },
        openMenuVisualComponent() {
            let items = [
                {
                    label: { fr: "Bleu", en: "Blue" },
                    //                        label: {fr: 'Nouvelle teinte', en: 'New shade'},
                    action: this.newVisualComponent,
                    args: ["blue", "#41B4E8"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Rouge", en: "Red" },
                    action: this.newVisualComponent,
                    args: ["red", "#FF0000"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Violet", en: "Purple" },
                    action: this.newVisualComponent,
                    args: ["purple", "#8A2BE2"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Jaune", en: "Yellow" },
                    action: this.newVisualComponent,
                    args: ["yellow", "#FFD700"]
                },
                {
                    //                        label: {fr: 'Nouveau module', en: 'New module'},
                    label: { fr: "Vert", en: "Green" },
                    action: this.newVisualComponent,
                    args: ["green", "#008000"]
                },
                {
                    label: { fr: "Annuler", en: "Cancel" },
                    action: this.newVisualComponent,
                    args: ["cancel"]
                }
            ];

            this.createMenu(items, true);
        },
        newVisualComponent(type) {
            let modules = this.modulesSelected;
            modules.forEach(module => {
                this.createVirtualComponent(module, type);
            });
        },
        // hideMenu (event) {
        //     let classNameTicketStripHide = (this.optionhideframe ? 'hide-option-selected ' : '') + 'hide-ticketsprip'
        //     let classNameHigRealisticHide = (this.optionhidehighlight ? 'hide-option-selected ' : '') + 'hide-realistic'
        //     let classNameFrameHide = (this.optionhideframe ? 'hide-option-selected ' : '') + 'hide-frame'
        //     let classNameHighlightHide = (this.optionhidehighlight ? 'hide-option-selected ' : '') + 'hide-highlights'
        //     let items = [
        //         {
        //             id: 'ticketstrip',
        //             addClass: classNameTicketStripHide,
        //             action: this.viewTicketstrip,
        //             label: 'planobuilder.ticketStrip'
        //         },
        //         {
        //             id: 'realistic',
        //             addClass: classNameHigRealisticHide,
        //             action: this.viewRealistic,
        //             label: 'planobuilder.realistic'
        //         },
        //         {
        //             id: 'frameHide',
        //             action: this.frameHide,
        //             addClass: classNameFrameHide,
        //             label: 'planobuilder.frameHide'
        //         },
        //         {
        //             id: 'highlights',
        //             action: this.highlight,
        //             addClass: classNameHighlightHide,
        //             label: 'planobuilder.highlights'
        //         }
        //     ]
        //     this.createMenu(items, false, true, event)
        // },
        frameHide() {
            this.optionhideframe = !this.optionhideframe;
            // d3.select('.content-menu-hide').select('.hide-frame').attr()
            // let elt = document.querySelector('.content-menu-hide .hide-frame')

            // if (this.optionhideframe) elt.classList.add('hide-option-selected')
            // else elt.classList.remove('hide-option-selected')

            d3.select("#meubleInt")
                .selectAll("rect.accessory-frame")
                .attr("visibility", this.optionhideframe ? "hidden" : "visible");
            let segD3 = d3.select("#meubleInt").selectAll("rect.accessory-segmentation");
            segD3.each((d, i, cmps) => {
                let parent = cmps[i].parentNode;
                d3.select(parent).attr("visibility", this.optionhideframe ? "hidden" : "visible");
            });
            // if (segD3.size() > 0) {
            //     let parent = segD3.node().parentNode
            //     d3.select('#meubleInt').selectAll('rect.accessory-segmentation').attr('visibility', this.optionhideframe ? 'hidden' : 'visible')
            // }
        },
        highlight() {
            this.optionhidehighlight = !this.optionhidehighlight;
            this.modeShades = "hide";

            // let elt = document.querySelector('.content-menu-hide .hide-highlights')

            // if (this.optionhidehighlight) elt.classList.add('hide-option-selected')
            // else elt.classList.remove('hide-option-selected')

            d3.select("#meubleInt")
                .selectAll("rect.ret-visual-component")
                .attr("visibility", this.optionhidehighlight ? "hidden" : "visible");
        },
        getJsonPlanoSimple() {
            let brandId = cacheService.getCurrentBrandId();
            let zoneId = cacheService.getCurrentZoneId();
            let campaignId = cacheService.getCurrentCampaignId();
            //                console.log(this.planoData, this.accessories, this.groups)
            let json = this.assign(this.planoData);
            // console.log(this.planoData, '=======')
            json.idPlano = this.$route.params.id;
            json.idCampaign = !campaignId ? null : campaignId;
            json.zoneId = !zoneId ? null : zoneId;
            json.brandId = !brandId ? null : brandId;
            json.modules = [];
            json.accessories = [];
            let allModules = [];
            let allTickets = [];
            let allShades = [];
            let updateShades = [];
            let allAccessories = [];
            let shadesByModule;
            let modules = this.getModules();
            let accessories = this.accessories;
            let moduleSimple;
            modules.forEach(mod => {
                moduleSimple = {};
                shadesByModule = [];
                let modId = parseInt(mod.id, 10);
                if (allModules.indexOf(modId) === -1) {
                    allModules.push(modId);
                }
                moduleSimple.id = modId;
                moduleSimple.position = { x: mod.posX, y: mod.posY };
                moduleSimple.size = { x: mod.size.width, y: mod.size.height };
                if (mod.config && mod.config.groups instanceof Array) {
                    let groups = mod.config.groups;
                    groups.forEach(group => {
                        let color = group.color;
                        if (color) {
                            //                                console.log(group.color)
                            shadesByModule.push(color.id);
                            if (allShades.indexOf(color.id) === -1) {
                                allShades.push(color.id);
                                // console.log(color)
                                updateShades.push({ id: color.id, color: color.color, number: color.ref });
                            }
                        }
                    });

                    moduleSimple.shades = shadesByModule;
                }

                if (mod.config && mod.config.tickets instanceof Array) {
                    let tickets = mod.config.tickets;
                    let tickets2;
                    tickets.forEach(ticket => {
                        tickets2 = ticket.tickets;
                        if (tickets2 instanceof Array) {
                            tickets2.forEach(tick => {
                                if (!allTickets.includes(tick.id)) {
                                    allTickets.push(tick.id);
                                }
                            });
                        }
                    });
                }

                json.modules.push(moduleSimple);
            });
            accessories.forEach(accessory => {
                // console.log(accessory)
                let accessoryId = parseInt(accessory.id, 10);
                let accesso = {
                    id: accessoryId,
                    position: { x: accessory.posX, y: accessory.posY },
                    size: { x: accessory.size.width, y: accessory.size.height }
                };

                json.accessories.push(accesso);

                if (allAccessories.indexOf(accessoryId) === -1) {
                    allAccessories.push(accessoryId);
                }
                //                    console.log(accessory, '===============================')
            });
            json.allModules = allModules;
            json.allShades = allShades;
            json.updateShade = updateShades;
            json.allAccessories = allAccessories;
            json.allTickets = allTickets;
            return json;
        },
        save(mode) {
            console.count("save ===");
            if (this.load === false) {
                alert("Attention: On ne peut pas sauvegarder tant que le plano n'est pas chargé");
                return;
            }
            let objectToSave = {};
            let groups = this.assign(this.groups);
            // console.log(groups)
            groups.forEach(group => {
                group.modules.forEach(mod => {
                    mod.selected = false;
                });
            });
            let accessories = this.assign(this.accessories);

            accessories.forEach(accessory => {
                accessory.selected = false;
            });
            if (mode === "saveExit") {
                if (this.getMeuble.plano) {
                    objectToSave = {
                        content: {
                            plano: this.getMeuble.plano,
                            groups: groups,
                            accessories: accessories
                        },
                        data_stats: this.getJsonPlanoSimple(),
                        isLocked: false
                    };
                } else {
                    objectToSave = {
                        content: {
                            plano: this.getMeuble,
                            groups: groups,
                            accessories: accessories
                        },
                        data_stats: this.getJsonPlanoSimple(),
                        isLocked: false
                    };
                }
            } else {
                if (this.getMeuble.plano) {
                    objectToSave = {
                        content: {
                            plano: this.getMeuble.plano,
                            groups: groups,
                            accessories: accessories
                        },
                        data_stats: this.getJsonPlanoSimple(),
                        isLocked: true
                    };
                } else {
                    objectToSave = {
                        content: {
                            plano: this.getMeuble,
                            groups: groups,
                            accessories: accessories
                        },
                        data_stats: this.getJsonPlanoSimple(),
                        isLocked: true
                    };
                }
            }

            return httpService.post("/plano/" + this.$route.params.id + "/config", JSON.stringify(objectToSave)).then(response => {
                if (mode === "saveExit") {
                    cacheService.set("planoLocked", false);
                    this.$store.state.plano.status.builder.groups = [];
                    this.$router.replace("/planos");
                } else {
                    Vue.toast("SAUVEGARGE REUSSIE", {
                        id: "my-toast",
                        className: ["my-toast", "toast-warning", "flexContainer", "txtCenter"],
                        horizontalPosition: "right",
                        verticalPosition: "bottom",
                        mode: "queue"
                    });
                    this.$store.state.plano.status.builder.modifiedUser = {
                        firstname: response.modifiedUser.firstname,
                        lastname: response.modifiedUser.lastname,
                        date: response.modifiedDate
                    };
                    this.setUpdatePlano(true);
                }
            });
        }
    }
};
</script>
<style lang="scss">
svg {
    .bgWhite {
        background-color: white !important;
        fill: white !important;
    }
}

.content-highlight {
    white-space: nowrap;

    .bt-highlight {
        vertical-align: top;
        display: inline-block;
        height: 12px;
        width: 20px;
        border: solid 1px #6f6f6f;
        margin-right: 1px;
    }
}

.lockScreenLogo {
    width: 23px;
    height: 25px;
    margin: auto;
}

.lockText {
    margin: auto;
    font-weight: bold;
}

.visibility {
    visibility: hidden;
}

#builderWrapper {
    overflow: hidden;
    .content-plano-builder {
        height: 100%;
    }
    /*flex: 1 100%;*/
    .sidebar {
        width: 25%;
        right: 0;
        z-index: 20;
        border-left: 2px solid #aaa;
    }
    .sidebarLeft {
        width: 25%;
        z-index: 25;
        border-right: 2px solid #aaa;
    }
    #menuView {
        margin: 20px 0;
        .titleView {
            font-size: 1.4rem;
            border: none;
            background-color: transparent;
        }
        .views {
            padding-left: 20px;
            li {
                margin-right: 15px;
                background-color: white;
                border: none;
                font-size: 1.4rem;
                padding: 14.5px 30px;
                &.active {
                    background-color: #41b4e8;
                    color: white;
                }
            }
        }
        #hide {
            background-color: white;
            border: none;
            font-size: 1.4rem;
            height: 45px;
            width: 100px;
            margin-top: 10px;
            padding-left: 20px;
        }
    }
}

#planoContainer {
    height: 100%;
    #toolBar {
        z-index: 20;
        height: 100%;
        top: 0;
        ul.listAction {
            margin: auto;
            li {
                margin-bottom: 20px;
                background-color: #fff;
                width: 40px;
                height: 40px;
                &.selection {
                    background-image: url("../../assets/Group_938-01.svg");
                }
                &.selectionSvg {
                    background-image: url("../../assets/selection.svg");
                }
                &.pan {
                    background-image: url("../../assets/main.svg");
                }
                &.panAction {
                    background-image: url("../../assets/Group_938-02.svg");
                }
                &.icon-ungroup-off {
                    background-image: url("../../assets/ungroup-off.svg");
                }

                &.icon-ungroup-off:active {
                    background-image: url("../../assets/ungroup-on.svg");
                }
            }
        }
        ul.listZoom {
            li {
                background-color: #ffffff;
                width: 40px;
                height: 40px;
                margin-bottom: 2px;

                &.pos {
                    background-image: url("../../assets/zoom.svg");
                }
                &.zoomModule {
                    background-image: url("../../assets/Group_938-04.svg");
                }
                &.zoomOut {
                    background-image: url("../../assets/Group_938-05.svg");
                }
                &.zoomIn {
                    background-image: url("../../assets/Group_938-06.svg");
                }

                &.moduleZ {
                    background-image: url("../../assets/zoomModule.svg");
                }

                &.posInit {
                    background-image: url("../../assets/Group_938-03.svg");
                }
            }
        }

        ul.listLayers {
            margin-top: 20px;
            li {
                background-color: #ffffff;
                width: 40px;
                height: 40px;

                &.layers-on {
                    background-image: url("../../assets/layers-on.svg");
                }

                &.layers-off {
                    background-image: url("../../assets/layers-off.svg");
                }
            }
        }
    }
    .svg-builder {
        width: 100%;
    }
}

#builder {
    /*flex: 1 100%;*/
    width: 100%;
    /*height: 100%;*/
    /*right: 0;*/
    text,
    & tspan {
        width: 100% !important;
        font-family: "Oswald", sans-serif !important;
        /*font-size: 30px !important;*/
        text-transform: uppercase;
    }
    .textDIAM,
    .textclient {
        /*font-size: 22px !important;*/
    }
}

#menuSelection {
    /*position: fixed;*/
    /*bottom: 0px;*/
    height: 55px;
    /*margin: 22px 0;*/
    margin-bottom: 45px;
    ul {
        padding-left: 0;
        margin: auto;
        li {
            font-size: 1.4rem;
            padding: 0 15px;
            &#content-count {
                font-weight: bold;
            }
            &#test {
                background: url("../../../static/assets/logo_Rem3rch.svg") no-repeat center;
                width: 30px;
                height: 30px;
                right: 50px;
                bottom: 15px;
            }
            &.disabled {
                opacity: 0.5;
            }
        }
    }
}

.content-menu,
.content-menu-hide {
    position: absolute;
    padding: 4px;
    z-index: 19;
    background: rgb(244, 244, 244);
    color: #000;
    cursor: pointer;
    font-size: 13px;
    font-family: "Roboto", Sans-Serif;
    border: 2px solid #fff;

    .layer-icon {
        vertical-align: middle;
        height: 16px;
        width: 20px;
        background-image: url("../../assets/eye.svg");
        background-repeat: no-repeat;
        display: inline-block;
        padding-right: 3px;
    }

    .layer-icon-hidden {
        visibility: hidden;
    }
}

.menu-item {
    padding: 5px 0px;
    background: rgb(244, 244, 244);
}

.menu-item:hover {
    background: rgb(200, 200, 200);
}

.hide-option-selected {
    background: #41b4e8;
    color: white;
}

@media only screen and (max-width: 767px) {
    #builder {
        right: auto;
        width: 100% !important;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #planoContainer {
        #toolBar {
            padding-right: 15px;
        }
    }
    .content-plano-builder {
        height: 70%;
    }
    #menuSelection {
        ul {
            li {
                font-size: 1.2rem;
            }
        }
    }
    #builderWrapper {
        #menuView {
            .views {
                li {
                    font-size: 1.1em;
                }
            }
        }
        .sidebar,
        .sidebarLeft {
            width: 45%;
        }
    }
}

/* Css popin Error */
.popinErrorModal {
    & .swal2-content {
        text-align: left;
        & li {
            text-transform: lowercase;
            font-size: 13px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// PlanoEditor.vue?028cad9c